module.exports = __webpack_public_path__ + "img/globe.9c2d165.svg";